module.exports = __webpack_public_path__ + "static/media/construyendo.8805ab51.png";